/** Tells the intermediate updates of a load stream apart from its completion. */
export enum LoadState {
  Loading = 'loading',
  Done = 'done',
}

/**
 * Narrows any `state`-discriminated load stream to its completed case.
 *
 * Every such stream — a download, a Bescheid load — is a union of progress updates and exactly one
 * completion, told apart by the same discriminant. `Extract` picks the completed member of whichever
 * union is passed in, so callers keep the payload of their own type instead of a per-union guard
 * repeating this one comparison.
 *
 * @param {T} value - An update from the stream.
 * @return {boolean} Whether it is the completion.
 */
export const isComplete = <T extends { state: LoadState }>(value: T): value is Extract<T, { state: LoadState.Done }> =>
  value.state === LoadState.Done;
